<script setup lang="ts">
import type { InputNumberEmits, InputNumberSlots, InputNumberProps as UInputNumberProps } from '#ui/types';
import { reactiveOmit } from '@vueuse/core';
import { useForwardPropsEmits } from 'reka-ui';
import { computed, useTemplateRef } from 'vue';
import InputNumber from '#ui/components/InputNumber.vue';

export type InputNumberProps<T extends number | null = number | null> = UInputNumberProps<T>;

const props = withDefaults(defineProps<InputNumberProps>(), {
	orientation: 'vertical',
});
const emits = defineEmits<InputNumberEmits>();
const slots = defineSlots<InputNumberSlots>();

const forward = useForwardPropsEmits(reactiveOmit(props, 'decrement', 'increment'), emits);

const inputRef = useTemplateRef('input');

defineExpose({
	inputRef: computed(() => inputRef.value?.inputRef),
});
</script>

<template>
	<InputNumber
		ref="input"
		v-bind="forward"
		:decrement="Object.assign({}, props.decrement, { color: 'neutral', class: 'text-dimmed' })"
		:increment="Object.assign({}, props.increment, { color: 'neutral', class: 'text-dimmed' })"
	>
		<template v-for="(_, slotName) in slots" #[slotName]="slotData: any">
			<slot :name="slotName" v-bind="slotData" />
		</template>
	</InputNumber>
</template>
